import { ICompanyFormation } from '../../../../Interfaces/ICompanyFormation';
import { IShareHolderFullObject } from '../../../../Interfaces/IShareHolder';
import { ICompanyFormationHasShareHolder } from '../../../../Interfaces/ICompanyFormationHasShareHolder';
import { ICompanyFormationAnswer } from '../../../../Interfaces/ICompanyFormationAnswer';
import { ICompanyFormationQuestion } from '../../../../Interfaces/ICompanyFormationQuestion';
import { ICompanyFormationOption } from '../../../../Interfaces/ICompanyFormationOption';
import React from 'react';
import { IPostcode } from '../../../../Interfaces/IPostcode';
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { checkString } from '../../../core/standardFunctions';
import { CompanyFormationAnswerSummary } from '../Founding/Childs/Summary/CompanyFormationAnswerSummary';
import { Search } from '@mui/icons-material';

export interface IProps {
  companyFormationObject: ICompanyFormation;
  shareHolderArray: IShareHolderFullObject[];

  shareHolderRelation: ICompanyFormationHasShareHolder[];
  companyFormationAnswerArray: ICompanyFormationAnswer[];
  companyFormationQuestionArray: ICompanyFormationQuestion[];
  companyFormationOptionArray: ICompanyFormationOption[];

  postCodeObject: IPostcode | undefined;
  addressPostCodeObject: IPostcode | undefined;

  setIdShareHolder: Function;
}

export const RAChangeSummaryComparison: React.FC<IProps> = ({
  companyFormationAnswerArray,
  companyFormationObject,
  shareHolderArray,
  companyFormationOptionArray,
  companyFormationQuestionArray,

  postCodeObject,
  addressPostCodeObject,
  shareHolderRelation,
  setIdShareHolder,
}) => {
  return (
    <>
      <Grid container ml={5} mr={5} spacing={2}>
        <Grid item sm={4}>
          <b>Vereinsname:</b>
        </Grid>
        <Grid item sm={8}>
          {checkString(companyFormationObject.CompanyName)}
        </Grid>

        <Grid item sm={4}>
          <b>Vereinssitz:</b>
        </Grid>
        <Grid item sm={8}>
          {checkString(companyFormationObject.Street)}{' '}
          {checkString(companyFormationObject.StreetNr)}
        </Grid>

        <Grid item sm={4}></Grid>
        <Grid item sm={8}>
          {postCodeObject === undefined ? (
            <>k.A.</>
          ) : (
            <>
              {checkString(postCodeObject.Postcode)}{' '}
              {checkString(postCodeObject.City)}
            </>
          )}
        </Grid>

        {(companyFormationObject.AddressStreet !== null ||
          companyFormationObject.AddressStreetNr !== null ||
          companyFormationObject.Postcode_AddressidPostcode !== null) && (
          <>
            <Grid item sm={4}>
              <b>Vereinsanschrift:</b>
            </Grid>
            <Grid item sm={8}>
              {checkString(companyFormationObject.AddressStreet)}{' '}
              {checkString(companyFormationObject.AddressStreetNr)}
            </Grid>

            <Grid item sm={4}></Grid>
            <Grid item sm={8}>
              {addressPostCodeObject === undefined ? (
                <>k.A.</>
              ) : (
                <>
                  {checkString(addressPostCodeObject.Postcode)}{' '}
                  {checkString(addressPostCodeObject.City)}
                </>
              )}
            </Grid>
          </>
        )}
      </Grid>
      <CompanyFormationAnswerSummary
        companyFormationAnswerArray={companyFormationAnswerArray}
        companyFormationOptionArray={companyFormationOptionArray}
        companyFormationQuestionArray={companyFormationQuestionArray}
      />

      <Box ml={5} mr={5}>
        <Typography variant='h6' mt={2} mb={2}>
          Vorstand
        </Typography>
        <Typography>
          Der Vorstand im Sinne des §26 BGB besteht aus{' '}
          {shareHolderRelation.length === 1
            ? `dem ${shareHolderRelation[0].FreeText}.`
            : shareHolderRelation.map((x, i) =>
                i + 1 === shareHolderRelation.length
                  ? `dem ${x.FreeText}.`
                  : `dem ${x.FreeText}, `
              )}
        </Typography>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell width={'20%'}>Funktion</TableCell>

              <TableCell width={'30%'}>Vorname</TableCell>
              <TableCell width={'30%'}>Nachname</TableCell>
              <TableCell width={'20%'}>Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shareHolderArray.map(x => (
              <TableRow>
                <TableCell sx={{ color: 'black' }}>
                  {shareHolderRelation
                    .filter(y => y.idShareHolder === x.idShareHolder)
                    .map(x => x.FreeText)
                    .join(', ')}
                </TableCell>

                <TableCell>{x.FirstName}</TableCell>
                <TableCell>{x.LastName}</TableCell>

                <TableCell>
                  <IconButton onClick={() => setIdShareHolder(x.idShareHolder)}>
                    <Search />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
